<template>
  <div id="container" v-bind:style="mapStyle"></div>
  <div class="input_style">
    <input
      type="text"
      placeholder="请输入搜索关键字"
      id="suggestId"
      size="20"
      :value="search"
      style="width: 260px"
    />
  </div>
  <div
    id="searchResultPanel"
    style="border: 1px solid #c0c0c0; width: 150px; height: auto; display: none"
  ></div>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitMap">确定</el-button>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name: "",
  props: {
    mapHeight: {
      type: Number,
      default: 500,
    },
    lngLat: { lng: 0, lat: 0 },
    mapZoom: 0,
  },
  emits: { "close-map": null, "change-map": null },
  setup(props, { emit }) {
    const data = reactive({
      mapStyle: {
        width: "100%",
        height: props.mapHeight + "px",
      },
      search: null, //搜素
      lnglat: "", //经纬度
      address: "", //详细地址
      center: { lng: 114.36, lat: 30.53 }, //默认理工校区
      zoom: 15,
    });
    // 获取父组件props
    const propsData = JSON.parse(JSON.stringify(props));
    //  watch(props, (newProps) => {
    //       // console.log(newProps, "currentBcurrentB");
    //       var propsData = JSON.parse(JSON.stringify(newProps));
    //        data.center = propsData.lngLat;
    //         data.zoom = propsData.mapZoom;
    //     });

    onMounted(() => {
      setTimeout(() => {
        initMap(); // 创建和初始化地图
      }, 0);
    });
    // 初始化地图
    const initMap = () => {
      var map = new BMapGL.Map("container");
      // 当父组件传过来经纬度的时候，标记该点，没有就默认标记理工校区
      if (propsData.lngLat.lng && propsData.lngLat.lat && propsData.mapZoom) {
        data.center = propsData.lngLat;
        data.zoom = propsData.mapZoom;
      }
      var point = new BMapGL.Point(data.center.lng, data.center.lat);
      map.centerAndZoom(point, data.zoom);
      map.enableScrollWheelZoom(true);
      // 创建点标记
      var marker = new BMapGL.Marker(
        new BMapGL.Point(data.center.lng, data.center.lat)
      );
      // 在地图上添加点标记
      map.addOverlay(marker);
      // 地图点击事件获取坐标-------
      map.addEventListener("click", function (e) {
        // 获取层级
        data.zoom = map.getZoom();
        map.clearOverlays(); //清除地图上所有覆盖物
        // 利用坐标获取地址的详细信息
        const geoCoder = new BMapGL.Geocoder();
        geoCoder.getLocation(e.latlng, (res) => {
          if (res.surroundingPois.length > 0) {
            // 当定位点不准确时，选择第一个地址，坐标点使用点击的点
            var location = res.surroundingPois[0];
            // res.address 省市区 location.title详细地点
            data.address = res.address + location.title;
            data.lnglat = e.latlng;
            // e.latlng为点击的点坐标，更精准
            ElMessageBox.confirm(
              `已选择地点：${data.address}，经度：${e.latlng.lng}，纬度：${e.latlng.lat}`,
              "地点确认",
              {
                confirmButtonText: "确定",
                cancelButtonText: "重新选择",
                type: "warning",
              }
            )
              .then(() => {
                // 在地图上添加点标记
                var marker = new BMapGL.Marker(
                  new BMapGL.Point(e.latlng.lng, e.latlng.lat)
                );
                map.addOverlay(marker);
              })
              .catch(() => {
                map.clearOverlays();
              });
          } else {
            data.lnglat = e.latlng;
            data.address = res.address;
            ElMessageBox.confirm(
              `已选择地点：${data.address}，经度：${e.latlng.lng}，纬度：${e.latlng.lat}`,
              "地点确认",
              {
                confirmButtonText: "确定",
                cancelButtonText: "重新选择",
                type: "warning",
              }
            )
              .then(() => {
                // 在地图上添加点标记
                var marker = new BMapGL.Marker(e.latlng.lng, e.latlng.lat);
                map.addOverlay(marker);
              })
              .catch(() => {
                map.clearOverlays();
              });
          }
        });
      });
      //关键字搜索地点
      var ac = new BMapGL.Autocomplete({
        //建立一个自动完成的对象
        input: "suggestId",
        location: map,
      });
      ac.addEventListener("onhighlight", function (e) {
        //鼠标放在下拉列表上的事件
        var str = "";
        var _value = e.fromitem.value;
        var value = "";
        if (e.fromitem.index > -1) {
          value =
            _value.province +
            _value.city +
            _value.district +
            _value.street +
            _value.business;
        }
        str =
          "FromItem<br />index = " +
          e.fromitem.index +
          "<br />value = " +
          value;

        value = "";
        if (e.toitem.index > -1) {
          _value = e.toitem.value;
          value =
            _value.province +
            _value.city +
            _value.district +
            _value.street +
            _value.business;
        }
        str +=
          "<br />ToItem<br />index = " +
          e.toitem.index +
          "<br />value = " +
          value;
        G("searchResultPanel").innerHTML = str;
      });
      var myValue;
      ac.addEventListener("onconfirm", function (e) {
        //鼠标点击下拉列表后的事件
        var _value = e.item.value;
        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        G("searchResultPanel").innerHTML =
          "onconfirm<br />index = " +
          e.item.index +
          "<br />myValue = " +
          myValue;
        //详细地址
        data.address = myValue;
        setPlace();
      });
      // 关键字搜索地点后，选中加标点
      function setPlace() {
        map.clearOverlays(); //清除地图上所有覆盖物
        function myFun() {
          var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
          map.centerAndZoom(pp, 18);
          map.addOverlay(new BMapGL.Marker(pp)); //添加标注
          // 获取层级
          data.zoom = map.getZoom();
          // 列表选中地点后没有再次点击其他地图点，存这个点
          data.lnglat = pp;
        }
        var local = new BMapGL.LocalSearch(map, {
          //智能搜索
          onSearchComplete: myFun,
        });
        local.search(myValue);
      }
      function G(id) {
        return document.getElementById(id);
      }
    };

    // 关闭弹窗
    const resetForm = () => {
      emit("close-map");
    };
    //确定选中地址
    const submitMap = () => {
      if (data.address && data.lnglat) {
        emit("change-map", data.address, data.lnglat, data.zoom);
        emit("close-map");
      } else {
        ElMessageBox.alert(
          "鼠标滚动可以放大缩小地图，点击地图选择位置，也可以搜索关键字选择位置！",
          "提示",
          {
            confirmButtonText: "确定",
            callback: (action) => {},
          }
        );
      }
    };
    return {
      ...toRefs(data),
      initMap,
      resetForm,
      submitMap,
    };
  },
};
</script>

<style scoped>
.input_style {
  position: absolute;
  top: 65px;
  border: 1px solid #eee;

  z-index: 999;
}
.input_style input {
  line-height: 42px;
  padding-left: 18px;
  font-size: 16px;
}
.tangram-suggestion-main {
  z-index: 9999999;
}
</style>